<template>
  <div class="px-5 py-4">
    <h3 class="text-primary text-center mb-3">Per prima cosa decidi le impostazioni per questa azienda</h3>

    <SettingsForm @submitForm="$emit('submitForm', $event)"></SettingsForm>
  </div>
</template>

<script>

export default {
  name: 'setup-start',
  components: {
    SettingsForm: () => import('../Utilities/SettingsForm'),
  },
};

</script>
